import React from 'react';
import createReactClass from 'create-react-class';
import FormControllerProxy from 'lib/form/controller_proxy';
import Checkbox from 'views/ui/form_elements/checkbox';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Theme } from 'ui_system/theme';

export default injectIntl(
  createReactClass({
    displayName: 'PrivacyPolicy',
    mixins: [FormControllerProxy],

    _anyroadPrivacyPolicy() {
      const linkAttrs = {
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'brand-color',
        style: { color: Theme.colors.linksDesignElementsBaseColor },
        'data-testid': 'privacy-policy-link',
      };
      return (
        <Checkbox {...this._formProps('anyroad_privacy_policy')}>
          <div>
            <FormattedMessage
              id="CONFIRM_HAVE_READ"
              defaultMessage="Please confirm that you have read and accept our booking platform <termsLink>AnyRoad's End User Terms</termsLink> and agree to the usage of your data according to <privacyLink>AnyRoad's Privacy Policy</privacyLink>."
              values={{
                termsLink: (chunks) => (
                  <a
                    {...linkAttrs}
                    href="https://www.anyroad.com/end-user-terms"
                  >
                    {chunks}
                  </a>
                ),
                privacyLink: (chunks) => (
                  <a {...linkAttrs} href="https://www.anyroad.com/privacy">
                    {chunks}
                  </a>
                ),
              }}
            />
          </div>
        </Checkbox>
      );
    },

    _customizeErrorText() {
      const { intl } = this.props;
      const guidePrivacyPolicyErrors = this._formProps(
        'privacy_policy_accepted'
      ).errors;
      const anyroadPrivacyPolicyErrors = this._formProps(
        'anyroad_privacy_policy'
      ).errors;
      if (guidePrivacyPolicyErrors && guidePrivacyPolicyErrors[0]) {
        this._formProps('privacy_policy_accepted').errors[0] =
          intl.formatMessage({
            id: 'PLEASE_ACCEPT_PRIVACY_POLICY',
            defaultMessage: 'Please accept our Privacy Policy',
          });
      }
      if (anyroadPrivacyPolicyErrors && anyroadPrivacyPolicyErrors[0]) {
        this._formProps('anyroad_privacy_policy').errors[0] =
          intl.formatMessage({
            id: 'PLEASE_ACCEPT_ANYROAD_TOS',
            defaultMessage:
              "Please accept AnyRoad's Terms of Service and Privacy Policy.",
          });
      }
    },

    _guidePrivacyPolicy(privacyPolicyLink, privacyPolicyLinkText) {
      const links = privacyPolicyLink.split('\n');
      const texts = privacyPolicyLinkText.split('\n');
      const linkAttrs = {
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'brand-color',
        style: { color: Theme.colors.linksDesignElementsBaseColor },
        'data-testid': 'privacy-policy-link',
      };
      const hasSecondPolicy = links.length > 1;

      return (
        <Checkbox
          {...this._formProps('privacy_policy_accepted')}
          dataTestProp="privacy-policy-checkbox"
        >
          <div>
            {hasSecondPolicy ? (
              <FormattedMessage
                id="CONFIRM_HAVE_READ_GUIDE_TWO_POLICIES"
                defaultMessage="Please confirm that you have read and accept our <link1>{policy1}</link1> and <link2>{policy2}</link2>"
                values={{
                  policy1: texts[0],
                  policy2: texts[1],
                  link1: (chunks) => (
                    <a {...linkAttrs} href={links[0]}>
                      {chunks}
                    </a>
                  ),
                  link2: (chunks) => (
                    <a {...linkAttrs} href={links[1]}>
                      {chunks}
                    </a>
                  ),
                }}
              />
            ) : (
              <FormattedMessage
                id="CONFIRM_HAVE_READ_GUIDE"
                defaultMessage="Please confirm that you have read and accept our <link1>{policy1}</link1>"
                values={{
                  policy1: texts[0],
                  link1: (chunks) => (
                    <a {...linkAttrs} href={links[0]}>
                      {chunks}
                    </a>
                  ),
                }}
              />
            )}
          </div>
        </Checkbox>
      );
    },

    render() {
      this._customizeErrorText();
      const {
        privacy_policy_link,
        privacy_policy_link_text,
        anyroadPrivacyPolicy,
      } = this.props;
      const styling = { textAlign: 'left' };
      const extraMobileClass = window.mobileDetect.mobile()
        ? ' mobile-privacy-policy'
        : '';

      return (
        <div
          className={`CheckoutWaiverContainer PrivacyPolicyContainer ${extraMobileClass}`}
          style={styling}
        >
          {anyroadPrivacyPolicy
            ? this._anyroadPrivacyPolicy()
            : this._guidePrivacyPolicy(
                privacy_policy_link,
                privacy_policy_link_text
              )}
        </div>
      );
    },
  })
);
